<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">판매등록</span>
            <span class="txt">판매 상품을 결제 등록, 수정, 삭제 할 수 있습니다.</span>
        </div>

        <div class="com-table-top">
            <span class="title">판매 등록</span>
        </div>
        <div class="com-table-wrap">
            <span class="top-title"><span class="title">상품 기본정보</span></span>
            <div class="com-card-input half-type">
                <div class="left-box full">
                    <div class="line">
                        <div class="division">
                            <span class="tit">
                                회원명
                                <span class="imp">*</span>
                            </span>
                            <div class="input-cnt">
                                <input
                                    v-model="searchCustomerStr"
                                    class="w220"
                                    type="text"
                                    @keyup.enter="onSearchList"
                                />
                                <button class="com-btn" @click="onSearchList">검색</button>
                            </div>
                        </div>
                        <div class="division">
                            <span class="tit">
                                상품명
                                <span class="imp">*</span>
                            </span>
                            <div class="input-cnt">
                                <select-form
                                    :select-data="['선택', ...itemList]"
                                    :select-value="['', ...itemValueList]"
                                    :selected-value="itemValue"
                                    class="w220"
                                    @update:set="(val) => (itemValue = val)"
                                ></select-form>
                                <div class="com-check">
                                    <input id="check-t1" v-model="directinput" name="check-t1" type="checkbox" />
                                    <label for="check-t1">직접입력</label>
                                </div>
                                <input
                                    v-model="directExpenseItem"
                                    :disabled="directinput == false"
                                    class="w220"
                                    type="text"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="line">
                        <div class="division">
                            <span class="tit">판매가</span>
                            <div class="input-cnt">
                                <input
                                    v-model="price"
                                    :disabled="directinput == false"
                                    class="w220"
                                    type="text"
                                    @keypress="isNumber($event)"
                                    @keyup="onKeyUpPrice"
                                />
                            </div>
                        </div>
                        <div class="division">
                            <span class="tit">재고수량</span>
                            <div class="input-cnt">
                                <input v-model="stock" :disabled="directinput == false" class="w220" type="text" />
                            </div>
                        </div>
                        <div class="division">
                            <span class="tit">
                                구매수량
                                <span class="imp">*</span>
                            </span>
                            <div class="input-cnt">
                                <input v-model="number" :disabled="stock <= 0" class="w60 center" type="text" />
                                <span class="txt">개</span>
                            </div>
                        </div>
                        <div class="division">
                            <span class="tit">
                                총 결제금액
                                <span class="imp">*</span>
                            </span>
                            <div class="input-cnt">
                                <input
                                    :disabled="stock <= 0"
                                    :value="total | numberFormatFilter"
                                    class="w220"
                                    type="text"
                                    @input="changeTotalPrice"
                                />
                                <span class="txt">원</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <span class="top-title"><span class="title">상품 결제정보</span></span>

            <div class="com-card-form only-payment">
                <div class="middle-area">
                    <!-- 결제 정보 -->
                    <div class="payment-box">
                        <span class="title">결제정보 - 1</span>
                        <ul class="info-list">
                            <li>
                                <span class="tit">
                                    <span class="imp">*</span>
                                    결제수단 :
                                </span>
                                <div class="info">
                                    <div class="flex">
                                        <div class="com-radio">
                                            <input
                                                id="radio-1-1"
                                                v-model="payType"
                                                name="radio-1"
                                                type="radio"
                                                value="C"
                                                @change="changePayType"
                                            />
                                            <label for="radio-1-1">카드</label>
                                        </div>
                                        <div class="com-radio">
                                            <input
                                                id="radio-1-2"
                                                v-model="payType"
                                                name="radio-1"
                                                type="radio"
                                                value="L"
                                                @change="changePayType"
                                            />
                                            <label for="radio-1-2">현금</label>
                                        </div>
                                        <div class="com-radio">
                                            <input
                                                id="radio-1-3"
                                                v-model="payType"
                                                name="radio-1"
                                                type="radio"
                                                value="B"
                                                @change="changePayType"
                                            />
                                            <label for="radio-1-3">계좌이체</label>
                                        </div>
                                        <!-- <div class="com-radio">
                                        <input type="radio" name="radio-1" id="radio-1-4" value="M" v-model="payType" @change="changePayType">
                                        <label for="radio-1-4">마일리지</label>
                                    </div> -->
                                        <div class="com-radio">
                                            <input
                                                id="radio-1-5"
                                                v-model="payType"
                                                name="radio-1"
                                                type="radio"
                                                value="E"
                                                @change="changePayType"
                                            />
                                            <label for="radio-1-5">기타</label>
                                        </div>
                                    </div>

                                    <div v-show="payType == 'C'" class="card-radio-box">
                                        <div class="com-radio-btn">
                                            <input
                                                id="radio-2-1"
                                                v-model="payCardType"
                                                :checked="payCardType == 'KB'"
                                                name="radio-2"
                                                type="radio"
                                                value="KB"
                                            />
                                            <label for="radio-2-1">KB국민</label>
                                        </div>
                                        <div class="com-radio-btn">
                                            <input
                                                id="radio-2-2"
                                                v-model="payCardType"
                                                :checked="payCardType == 'BC'"
                                                name="radio-2"
                                                type="radio"
                                                value="BC"
                                            />
                                            <label for="radio-2-2">비씨</label>
                                        </div>
                                        <div class="com-radio-btn">
                                            <input
                                                id="radio-2-3"
                                                v-model="payCardType"
                                                :checked="payCardType == 'SM'"
                                                name="radio-2"
                                                type="radio"
                                                value="SM"
                                            />
                                            <label for="radio-2-3">삼성</label>
                                        </div>
                                        <div class="com-radio-btn">
                                            <input
                                                id="radio-2-4"
                                                v-model="payCardType"
                                                :checked="payCardType == 'HY'"
                                                name="radio-2"
                                                type="radio"
                                                value="HY"
                                            />
                                            <label for="radio-2-4">현대</label>
                                        </div>
                                        <div class="com-radio-btn">
                                            <input
                                                id="radio-2-5"
                                                v-model="payCardType"
                                                :checked="payCardType == 'LO'"
                                                name="radio-2"
                                                type="radio"
                                                value="LO"
                                            />
                                            <label for="radio-2-5">롯데</label>
                                        </div>
                                        <div class="com-radio-btn">
                                            <input
                                                id="radio-2-6"
                                                v-model="payCardType"
                                                :checked="payCardType == 'SH'"
                                                name="radio-2"
                                                type="radio"
                                                value="SH"
                                            />
                                            <label for="radio-2-6">신한</label>
                                        </div>
                                        <div class="com-radio-btn">
                                            <input
                                                id="radio-2-7"
                                                v-model="payCardType"
                                                :checked="payCardType == 'WH'"
                                                name="radio-2"
                                                type="radio"
                                                value="WH"
                                            />
                                            <label for="radio-2-7">외한</label>
                                        </div>
                                        <div class="com-radio-btn">
                                            <input
                                                id="radio-2-8"
                                                v-model="payCardType"
                                                :checked="payCardType == 'HA'"
                                                name="radio-2"
                                                type="radio"
                                                value="HA"
                                            />
                                            <label for="radio-2-8">하나</label>
                                        </div>
                                        <div class="com-radio-btn">
                                            <input
                                                id="radio-2-9"
                                                v-model="payCardType"
                                                :checked="payCardType == 'NH'"
                                                name="radio-2"
                                                type="radio"
                                                value="NH"
                                            />
                                            <label for="radio-2-9">NH농협</label>
                                        </div>
                                        <div v-show="isMoreCard" class="com-radio-btn">
                                            <input
                                                id="radio-2-10"
                                                v-model="payCardType"
                                                :checked="payCardType == 'WH'"
                                                name="radio-2"
                                                type="radio"
                                                value="WH"
                                            />
                                            <label for="radio-2-10">우리</label>
                                        </div>
                                        <div v-show="isMoreCard" class="com-radio-btn">
                                            <input
                                                id="radio-2-19"
                                                v-model="payCardType"
                                                :checked="payCardType == 'ET'"
                                                name="radio-2"
                                                type="radio"
                                                value="ET"
                                            />
                                            <label for="radio-2-19">기타</label>
                                        </div>
                                        <button v-show="!isMoreCard" class="more-btn" @click="isMoreCard = true">
                                            + 더보기
                                        </button>
                                    </div>
                                </div>
                            </li>
                            <!-- 결제수단 현금,계좌이체 일시 -->
                            <li v-show="payType == 'L' || payType == 'B'">
                                <span class="tit">영수증발행 :</span>
                                <div class="center-line">
                                    <div class="com-radio">
                                        <input
                                            id="radio-money-1"
                                            v-model="receiptType"
                                            name="radio-money"
                                            type="radio"
                                            value="N"
                                        />
                                        <label for="radio-money-1">미신청</label>
                                    </div>
                                    <div class="com-radio">
                                        <input
                                            id="radio-money-2"
                                            v-model="receiptType"
                                            name="radio-money"
                                            type="radio"
                                            value="C"
                                        />
                                        <label for="radio-money-2">현금영수증</label>
                                    </div>
                                    <div class="com-radio">
                                        <input
                                            id="radio-money-3"
                                            v-model="receiptType"
                                            name="radio-money"
                                            type="radio"
                                            value="T"
                                        />
                                        <label for="radio-money-3">세금계산서</label>
                                    </div>
                                    <div class="input-line">
                                        <input class="w220" placeholder="번호입력" type="text" />
                                    </div>
                                </div>
                            </li>
                            <!-- //결제수단 현금,계좌이체 일시 -->
                            <!-- 결제수단 마일리지 일시 -->
                            <li v-show="payType == 'M'">
                                <span class="tit">보유 마일리지 :</span>
                                <div class="info">
                                    <span class="txt-info">300,000 원</span>
                                    <div class="input-line">
                                        <div class="com-check">
                                            <input id="check-mileage-1" name="check-mileage" type="checkbox" />
                                            <label for="check-mileage-1">모두사용</label>
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li v-show="payType == 'M'">
                                <span class="tit">사용 마일리지 :</span>
                                <div class="info">
                                    <input class="w220" type="text" />
                                    <span class="txt">원</span>
                                </div>
                            </li>
                            <li v-show="payType == 'M'">
                                <span class="tit">마일리지 잔액 :</span>
                                <div class="info">
                                    <span class="txt-info">0 원</span>
                                </div>
                            </li>
                            <!-- //결제수단 마일리지 일시 -->
                            <li>
                                <span class="tit">
                                    <span class="imp">*</span>
                                    결제일자 :
                                </span>
                                <div class="info">
                                    <single-calendar
                                        :start-date="buyDate"
                                        class="w220"
                                        @update="updateDate"
                                    ></single-calendar>
                                </div>
                            </li>
                            <li>
                                <span class="tit">
                                    <span class="imp">*</span>
                                    판매자 :
                                </span>
                                <div class="info">
                                    <select-form
                                        :select-data="['선택', ...staffList]"
                                        :select-value="['', ...staffValueList]"
                                        :selected-value="selectedSeller"
                                        class="w220"
                                        @update:set="(val) => (selectedSeller = val)"
                                    ></select-form>
                                </div>
                            </li>
                            <li>
                                <span class="tit">메모</span>
                                <div class="info">
                                    <textarea v-model="memo" class="com-textarea w1000"></textarea>
                                </div>
                            </li>
                        </ul>
                        <span class="title">마일리지</span>
                        <ul class="info-list">
                            <li class="pl-180">
                                <span class="tit">적립 ({{ mileagePercent }}%) :</span>
                                <div class="info">
                                    <input :value="mileage | numberFormatFilter" type="text" @input="changeMileage" />
                                    <span class="txt">원 적립예정</span>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <div class="bottom-btn">
            <!-- <button class="com-btn">취소</button> -->
            <router-link :to="{ name: 'SalesSell' }" class="com-btn">취소</router-link>
            <button class="com-btn blue" @click="addItem">등록</button>
        </div>

        <!-- 회원 검색 결과 팝업 -->
        <div v-show="userPop" class="layer-pop square-type">
            <div class="view-content">
                <div class="scroll-area com-scroll-y">
                    <span class="sub-title">회원 검색 결과</span>
                    <div class="top-search-area">
                        <div class="right">
                            <input
                                ref="refCustomerName"
                                v-model="searchCustomerStr"
                                class="w220"
                                placeholder="회원명"
                                type="text"
                                v-on:keyup.enter="onSearchCustomer"
                            />
                            <button class="com-btn" @click="onSearchCustomer">검색</button>
                        </div>
                    </div>
                    <table class="com-table">
                        <colgroup>
                            <col style="width: 70px" />
                            <col style="width: 120px" />
                            <col style="width: 160px" />
                            <col style="width: 160px" />
                        </colgroup>
                        <thead>
                            <tr>
                                <th></th>
                                <th>회원명</th>
                                <th>연락처</th>
                                <th>생년월일</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(c, index) in searchCustomerList" :key="index">
                                <td>
                                    <div class="com-radio">
                                        <input
                                            :id="`radio-pop-${index + 1}`"
                                            v-model="pickedCustomerId"
                                            :value="c.center_cust_id"
                                            name="radio-pop"
                                            type="radio"
                                        />
                                        <label :for="`radio-pop-${index + 1}`"></label>
                                    </div>
                                </td>
                                <td>{{ c.namee }}</td>
                                <td>{{ c.phone | phoneNumberFilter }}</td>
                                <td>{{ c.birthday | dateFormatFilter }}</td>
                            </tr>
                            <tr v-if="searchCustomerList.length === 0">
                                <td colspan="100">등록된 내용이 없습니다.</td>
                            </tr>
                        </tbody>
                    </table>
                    <b-pagination
                        align="center"
                        aria-controls="my-table"
                        first-class="first"
                        last-class="last"
                        next-class="next"
                        prev-class="prev"
                    ></b-pagination>
                    <div class="bottom-btn">
                        <button class="com-btn" @click="onClickCancleSearchPop">취소</button>
                        <button class="com-btn blue" @click="onClickPickCustomer">선택</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import moment from 'moment';
import { Utils } from '../../../assets/js/utils.js';
import { pagingInfo } from '@/assets/js/common';

export default {
    name: 'SalesSellSetting',
    props: {},
    computed: {
        cId() {
            const { getters } = this.$store;
            return getters['auth/cId'];
        },
        staffId() {
            const { getters } = this.$store;
            return getters['auth/staffId'];
        },
        // total:function(){
        //     let totalPrice = this.getPureNumber ( this.price ) * this.number;
        //     return totalPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") // 결제금액 계산
        // },
        // mileage:function(){
        //     return this.percentMileage * this.getPureNumber ( this.total );
        // },
        mileagePercent() {
            const mileageSetting = this.mileageSetting;
            const payType = this.payType;
            if (payType === 'C' && mileageSetting.tickCardYn) {
                return mileageSetting.ticketCardRatio;
            } else if (payType === 'L' && mileageSetting.tickCashYn) {
                return mileageSetting.ticketCashRatio;
            } else if (payType === 'B' && mileageSetting.ticketBankRatio) {
                return mileageSetting.ticketBankRatio;
            } else if (payType === 'E' && mileageSetting.tickEtcYn) {
                return mileageSetting.ticketEtcRatio;
            }

            return '0.00';
        },
    },
    watch: {
        itemValue(newValue) {
            this.centerProductId = newValue;
            this.onSelectItem();
        },
        payType(newValue) {
            if (this.mileageSetting.tickCardYn == true && newValue == 'C') {
                this.percentMileage = this.mileageSetting.ticketCardRatio / 100;
            } else if (this.mileageSetting.tickCashYn == true && newValue == 'L') {
                this.percentMileage = this.mileageSetting.ticketCashRatio / 100;
            } else if (this.mileageSetting.tickBankYn == true && newValue == 'B') {
                this.percentMileage = this.mileageSetting.ticketBankRatio / 100;
            } else if (this.mileageSetting.tickEtcYn == true && newValue == 'E') {
                this.percentMileage = this.mileageSetting.ticketEtcRatio / 100;
            }
            if (newValue == 'M') {
                this.percentMileage = 0;
            }
        },
        receiptType(value) {
            if (value === 'C' && this.texTelNo !== 0) {
                this.editField.receiptNo = this.taxTelNo;
            }
        },
        number(value) {
            if (value <= this.stock) {
                this.number = value.replace(/[^0-9]/gi, '');
            } else if (value >= this.stock) {
                this.number = this.stock;
            } else {
                this.number = 0;
            }
            this.total = this.number * this.getPureNumber(this.price);
            this.mileage = this.getPureNumber(Math.floor((this.mileagePercent * this.total) / 100));
        },
    },
    data() {
        return {
            searchCustomerStr: '', // 회원 검색 키워드
            searchCustomerList: [],
            pickedCustomerId: '', // 선택한 회원의 customerId
            customerId: '',

            centerId: '',
            centerProductId: '',
            centerCustomerId: '', // 회원 아이디
            isMoreCard: false,
            directinput: false, // 직접입력 버튼
            buyCount: '', // 갯수
            buyDate: moment().format('YYYY-MM-DD'), // 결제일자 YYYYMMDD
            payType: 'C', // 기본값은 카드 결제.
            payCardType: 'KB', // 기본값은 KB
            payBankType: '',
            percentMileage: '',
            itemList: [],
            itemValueList: [],
            itemValue: '',
            userPop: false, // 회원 검색 팝업

            price: '', // 판매가
            stock: '', // 재고
            number: 0, // 갯수

            total: '',
            mileage: '',

            staffList: [],
            staffValueList: [],
            productName: '',
            directExpenseItem: '', // 직접입력시
            customerInfo: {},
            pagingInfo: { ...pagingInfo },
            selectedSeller: '',
            memo: '',
            mileageSetting: {},
            receiptType: '',
        };
    },
    mounted() {
        this.centerId = this.cId; // 센터 Id
        (this.selectedSeller = parseInt(this.staffId)), // 스태프아이디 설정
            // 회원목록 마운트1
            // 상품목록 마운트2

            // 스태프목록 마운트

            this.init();
    },
    methods: {
        // 초기화
        async init() {
            try {
                await this.onItemList();
                await this.onStaffList();
                const { data } = await this.getMileage();
                this.mileageSetting = data;
                if (data.tickCardYn == true && this.payType == 'C') {
                    this.percentMileage == data.ticketCardRatio / 100;
                }
            } catch (error) {
                console.log(error);
                console.log('error');
            }
        },
        // 상품등록
        async addItem() {
            try {
                const validate = this.validateReturnValues();
                if (!validate.result) {
                    alert(validate.msg);
                    return false;
                }
                // 상품등록시 직접입력인 경우
                if (this.directinput == true) {
                    const result = await this.fetchDirectItemPost();
                    console.log('직접등록 성공여부', result);
                    this.centerProductId = result.data.centerProductId; // 새로생생된 상품의 값을 부여
                }

                const { data } = await this.contractAdd();
                console.log('성공', data);
                alert('등록되었습니다.');
                await this.$router.push({ name: 'SalesSell' });
            } catch (error) {
                console.log(error);
                console.log('error입니다.');
            }
        },

        // 상품등록 api
        contractAdd() {
            // 스웨거 검색: 판매등록(유니폼) 등록
            return api.post(`/admin/api/center/${this.centerId}/uniform/contract`, {
                centerCustomerId: this.customerId,
                stocKManualYn: this.directinput,
                centerProductId: this.centerProductId,
                productName: this.directinput ? this.directExpenseItem : this.productName,
                buyCount: this.number,
                billPrice: this.getPureNumber(this.total),
                billInfo: {
                    debtYn: true,
                    billSeq: 0,
                    buyDate: this.buyDate,
                    billPrice: this.getPureNumber(this.total),
                    payType: this.payType,
                    payCardType: this.payCardType,
                    payBankType: this.payBankType,
                    mileage: Utils.getPureNumber(this.mileage),
                },
                saleStaffId: this.selectedSeller,
                memo: this.memo,
            });
        },
        // 판매시간설정
        updateDate(date) {
            // this.buyDate = date.replace(/\-/g,'');
            this.buyDate = date;
            console.log(this.buyDate);
        },

        // 회원목록 가져오기
        async onSearchList() {
            try {
                this.userPop = true;
                console.log(this.searchCustomerStr);
                const { data } = await this.sendGetCustomer();
                console.log('이름검색', data);
                this.searchCustomerList = data.items;
            } catch (error) {
                console.log(error);
                alert('이름이 맞는 회원이 없습니다.');
            }
        },
        // 회원목록 API
        getMemberList() {
            return api.get(`/admin/api/center/${this.centerId}/customer`, {
                params: {
                    ...this.pagingInfo,
                    searchStr: this.name,
                },
            });
        },
        // 상품목록 가져오기
        async onItemList() {
            try {
                this.isLoading = true;
                this.pagingInfo.limit = 100;
                const { data } = await this.getItemList();
                data.items.forEach((g) => {
                    this.itemList.push(g.cp_namee);
                    this.itemValueList.push(g.cp_center_prod_id);
                    console.log(this.itemList);
                    console.log(this.itemValueList);
                });
                console.log('===> Success Loading centerList : ', data);
            } catch (error) {
                console.log(error);
                alert('오류가 발생했습니다.');
            }
        },
        // 상품목록 API
        getItemList() {
            return api.get(`/admin/api/center/${this.centerId}/uniform/product`, {
                params: {
                    ...this.pagingInfo,
                },
            });
        },
        // 상품명선택
        async onSelectItem() {
            try {
                if (this.centerProductId == null || this.centerProductId == '') {
                    // 값이 없을경우 초기화
                    this.price = '';
                    this.stock = '';
                } else {
                    const { data } = await this.getItemInfo();
                    console.log('아이템이 선택되었습니다', data);
                    this.productName = data.name;
                    this.price = data.sellPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');

                    if (data.stockType == 'U') data.stockTotalCount = '9999';

                    if (data.stockTotalCount > 0) {
                        this.stock = data.stockType == 'U' ? '무제한' : data.stockTotalCount;
                    } else {
                        this.stock = 0;
                        alert('물품수량이 부족합니다');
                    }
                }
            } catch (error) {
                console.log(error);
                alert('오류가 발생했습니다.');
            }
        },

        // 상품명 선택됬을때 함수
        getItemInfo() {
            return api.get(`/admin/api/center/${this.centerId}/uniform/product/${this.centerProductId}`);
        },

        // 스태프목록 불러오기
        async onStaffList() {
            try {
                this.isLoading = true;
                const { data } = await this.getStaffList();
                data.sort(
                    (
                        a,
                        b // order by 정렬
                    ) => (a.name < b.name ? -1 : a.name > b.name ? 1 : 0)
                );
                console.log('스태프', data);
                data.forEach((g) => {
                    this.staffList.push(g.name);
                    this.staffValueList.push(g.centerStaffId);
                });
                console.log('===> Success Loading centerList : ', data);
            } catch (error) {
                console.log(error);
                alert('오류가 발생했습니다.');
            }
        },
        // 스태프목록 API
        getStaffList() {
            return api.get(`/admin/api/center/${this.centerId}/staff/teachers/list`);
        },
        // 회원명으로 회원 검색
        async onSearchCustomer() {
            try {
                const { data } = await this.sendGetCustomer();
                console.log(data);
                // this.setPageParams(data, 'customer');
                this.searchCustomerList = data.items;
            } catch (error) {
                alert('회원 검색 중 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // 센터 회원 페이징 목록 조회
        sendGetCustomer() {
            return api.get(`/admin/api/center/${this.centerId}/customer`, {
                params: {
                    // ...this.customerPagingInfo,
                    ...this.pagingInfo,
                    searchStr: this.searchCustomerStr,
                },
            });
        },
        // 회원 검색 팝업 취소 버튼 클릭시
        onClickCancleSearchPop() {
            this.userPop = false;
            this.searchCustomerStr = '';
            this.searchCustomerList = [];
        },
        // 회원 검색 팝업 선택 버튼 클릭시
        async onClickPickCustomer() {
            if (this.pickedCustomerId === '') {
                alert('회원을 선택하세요.');
                return;
            }
            await this.fetchCustomerDetail(this.pickedCustomerId); // 선택한 회원 id로 customer 상세 정보 가져옴
            this.customerId = this.pickedCustomerId; // 현재 페이지의 customerId를 넣어줌

            this.searchCustomerStr = this.customerInfo.name;

            // 회원 검색 관련 변수 초기화
            this.userPop = false;
            // this.searchCustomerStr = '';
            this.searchCustomerList = [];
            this.pickedCustomerId = '';
        },

        // 센터 회원 기본 정보 가져오기
        async fetchCustomerDetail(customerId) {
            try {
                const { data } = await this.sendGetCustomerDetail(customerId);
                this.customerInfo = data; // 가져온 그대로 customerInfo에 넣기
                // let { editField } = this;

                // editField.name = this.customerInfo.name;
            } catch (error) {
                alert('회원 정보를 가져오는 중 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // 센터 회원 기본 정보 조회 API 호출
        sendGetCustomerDetail(customerId) {
            return api.get(`/admin/api/center/${this.centerId}/customer/${customerId}`);
        },
        // 파라미터 validate
        validateReturnValues() {
            // 필수값 체크
            let result = false;
            const { customerId, productName, number, payType, buyDate, selectedSeller, directinput, stock } = this;
            let msg = '';

            if (stock <= 0) {
                msg = '물품수량이 부족합니다';
                return { result, msg };
            }

            // 회원명
            if (customerId === '' || customerId === undefined) {
                msg = '회원을 선택하세요.';
                return { result, msg };
            }

            // 상품
            if ((directinput == false && productName === '') || productName === undefined) {
                msg = '상품을 선택하세요.';
                return { result, msg };
            }
            if (payType === '' || payType === undefined) {
                msg = '결제수단을 선택하세요.';
                return { result, msg };
            }

            // 구매수량
            if (number === '' || number === undefined) {
                msg = '수량을 입력하세요.';
                return { result, msg };
            }
            // 날짜선택
            if (buyDate === '' || buyDate === undefined) {
                msg = '날짜를 선택하세요.';
                return { result, msg };
            }
            // 판매자 여부
            if (selectedSeller === '' || selectedSeller === undefined) {
                msg = '판매자를 선택하세요.';
                return { result, msg };
            }

            if (msg !== '') {
                result = false;
            } else {
                result = true;
            }

            return { result, msg };
        },
        // 센터마일리지 관련 정보획득
        getMileage() {
            return api.get(`/admin/api/centerMileage/${this.centerId}`);
        },
        getNumberFormat(num) {
            if (typeof num !== 'number' || num === undefined || num === '') {
                return num;
            }
            return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        },
        onKeyUpPrice() {
            // 결제 금액 업데이트
            const num = this.getPureNumber(this.price);
            console.log('num', num);
            this.price = this.getNumberFormat(num);
        },
        getPureNumber(num) {
            if (typeof num !== 'string' || num === undefined || num === '') {
                return num;
            }
            return parseInt(num.toString().replace(/[,-]/g, ''));
        },
        isNumber(evt) {
            evt = evt || window.event;
            const charCode = evt.which ? evt.which : evt.keyCode;
            if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        changeTotalPrice(e) {
            this.total = this.getPureNumber(e.target.value);
            this.mileage = Math.floor((this.mileagePercent * this.total) / 100);
            console.log(this.total);
        },
        changeNumber(e) {
            const nu = parseInt(e.data, 10);
            if (nu >= 0 && nu < 10) {
                this.total = this.number * this.getPureNumber(this.price);
                this.mileage = this.getPureNumber(Math.floor((this.mileagePercent * this.total) / 100));
            } else {
            }
        },
        changePayType() {
            this.mileage = Math.floor((this.mileagePercent * this.total) / 100);
        },
        changeMileage(e) {
            const num = this.getPureNumber(e.target.value);
            this.mileage = this.getNumberFormat(num);
        },
        // 직접입력시 새로 생성하는 데이터.
        fetchDirectItemPost() {
            return api.post(`/admin/api/center/${this.centerId}/uniform/product`, {
                params: {
                    productName: this.directExpenseItem,
                    recvPrice: this.price,
                    sellPrice: this.price,
                    stockType: 'L',
                    stockTotalCount: this.stock,
                    stockUseYn: true,
                    onceType: 'O',
                },
            });
        },
    },
};
</script>
<style lang="scss"></style>
